import script from "./PotentialPolicy.vue?vue&type=script&setup=true&lang=js"
export * from "./PotentialPolicy.vue?vue&type=script&setup=true&lang=js"

import "./PotentialPolicy.vue?vue&type=style&index=0&id=32f5c656&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32f5c656"]])

export default __exports__